import Filterizr from 'filterizr';

export default {



  initFiltering() {
    if( $('.filter-container').length > 0){

      const grid_options = {
        layout: 'sameWidth',
        gutterPixels: 24,
        callbacks: {
          onInit: function() {
            forceSameHeight()
            $(this).addClass('filterizred')
          },
          onFilteringStart: function() { forceSameHeight()}
        },
        filterOutCss: { // Filtering out animation
          opacity: 0
        },
        filterInCss: { // Filtering in animation
          opacity: 1
        }
      };

      const list_options = {
        layout: 'vertical',
        gutterPixels: 0,
        callbacks: {
          onInit: function() {removeForcedHeight()},
          onFilteringStart: function() {removeForcedHeight()}
        },
        filterOutCss: { // Filtering out animation
          opacity: 0,
          transform: 'scale(1, 1)'
        },
        filterInCss: { // Filtering in animation
          opacity: 1,
          transform: 'scale(1, 1)'
        }
      };
      const filterizr = new Filterizr('.filter-container', grid_options);

      if(window.location.hash != ''){
        var filter = window.location.hash.replace('#', '');
        filterizr.filter(filter);
      }

      $('.projects-display-type-buttons button').on( "click", function() {
        if (!$(this).hasClass('selected')) {
            $('.projects').addClass('projects--hidden');

            setTimeout(function(){
              filterizr.filter('all'); //fix going back to grid from filtered list
              $('.projects').toggleClass('projects--grid projects--list');
              $('.projects-display-type-buttons button').toggleClass('selected');
              $('.projects').changeProjectsMarkup();

              var filter = window.location.hash.replace('#', '');
              if(filter == ''){filter = 'all';}

              if ($('.projects').hasClass('projects--grid')) {
                filterizr.setOptions(grid_options);
              }else{
                filterizr.setOptions(list_options);
              }
              filterizr.filter(filter);

              $('.projects').removeClass('projects--hidden');
            }, 300);
        }
      });

      $(window).on('resize orientationchange', function() {
        if ($('.projects').hasClass('projects--grid')) {
          filterizr.setOptions(grid_options);
        }else{
          filterizr.setOptions(list_options);
        }
        filterizr.filter(filter);
      })

      forceSameHeight();

      function forceSameHeight(){
        var maxHeight = -1;

        removeForcedHeight()

        $('.project').each(function() {
          maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
        });

        $('.project').each(function() {
          $(this).height(maxHeight);
        });
      }

      function removeForcedHeight(){
        $('.project').each(function() {
          $(this).css('height', 'auto');
        });
      }
    }
  }
}

$.fn.ToggleProjectCategories = function() {
  let self = this
  self.find('.toggle-category-menu, .project-categories__link').click(function() {
    self.toggleClass('projects-sidebar--hidden projects-sidebar--extended')
  });

  return function() {
    return self
  }()
}

$.fn.changeProjectsMarkup = function() {
  let self = this
  if (self.hasClass('projects--grid')) {
    self.find('.project__location').each(function() {
        $(this).next('.project__year').andSelf().wrapAll('<span class="one-liner"/>');
    });
  }else{
    self.find('.one-liner .project__location').unwrap();
  }

  return function() {
    return self
  }()
}

$.fn.selectProjectCategory = function() {
  let self = this

  self.on( "click", function() {
    var filter = $(this).attr('data-filter');
    if(filter == 'all'){
      history.pushState(null, null, ' ');
    }else{
      window.location.hash = '#' + filter;
    }

    $('.project-categories__link').removeClass('project-categories__link--active');
    self.addClass('project-categories__link--active');
  });


  return function() {
    return self
  }()
}
